import InstrumentModel from "@/models/lab/InstrumentModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class InstrumentCollection extends LabServiceCollection {
  model() {
    return InstrumentModel;
  }

}
